import React, { useEffect, useState } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { useBlogNavigation } from '../../hooks/navigation/useBlogNavigation'
import { buildUrl } from '../../services/urlService'
import { setFontWeightClassNames } from '../../services/forceFontWeightService'

const HomepageCarouselSlideContent = ({ headerImage, openVideoModalCallback, locale }) => {
  const defaultSectionClassNames = 'image-slide p-0 text-light has-bgimg sm-top-padding'
  const blogNavigation = useBlogNavigation(locale)
  const [linkUrl, setLinkUrl] = useState(null)
  const [linkText, setLinkText] = useState(null)
  const [videoLink, setVideoLink] = useState(null)
  const [videoText, setVideoText] = useState(null)
  const [showImiLogo, setShowImiLogo] = useState(false)
  const imageToDisplay = getImage(headerImage.image)
  const [preTitleImageToDisplay, setPreTitleImageToDisplay] = useState(null)
  const [sectionClassNames, setSectionClassNames] = useState(defaultSectionClassNames)
  const [subTitleClassNames, setSubTitleClassNames] = useState('force-font__light')

  useEffect(() => {
    let showLink = false
    let showVideo = false

    if (headerImage.navigateTo) {
      setLinkUrl(buildLinkUrl(headerImage.navigateTo, ''))
      setLinkText(headerImage.navigationButtonText)
      showLink = true
    } else {
      setLinkUrl(null)
      setLinkText(null)
    }

    if (headerImage.vimeoVideo && showLink === false) {
      setVideoText(headerImage.vimeoVideo.buttonText)
      setVideoLink(headerImage.vimeoVideo.vimeoLink)
      showVideo = true
    } else {
      setVideoText(null)
      setVideoLink(null)
    }

    if (headerImage.displayImiLogo === true && showLink === false && showVideo === false) {
      setShowImiLogo(true)
    } else {
      setShowImiLogo(false)
    }

    if (headerImage.applyTint === true) {
      setSectionClassNames(defaultSectionClassNames)
    } else {
      setSectionClassNames(`${defaultSectionClassNames} no-tint`)
    }

    setFontWeightClassNames(headerImage.subtitleFontWeight, setSubTitleClassNames)

    if (headerImage.preTitleImage) {
      setPreTitleImageToDisplay(getImage(headerImage.preTitleImage))
    } else {
      setPreTitleImageToDisplay(null)
    }
  }, [headerImage])

  const buildLinkUrl = (node, url) => {
    if (node.navigation_element !== null && node.navigation_element !== undefined) {
      url = buildLinkUrl(node.navigation_element[0], url)
    }

    if (node.internal?.type && node.internal.type === 'ContentfulBlog') {
      url = buildUrl(blogNavigation, url)
    }

    if (node.slug) {
      url = url + '/' + node.slug
    }

    return url
  }

  const openVideoModal = (e) => {
    e.preventDefault()

    if (openVideoModalCallback) {
      openVideoModalCallback(videoLink)
    }
  }

  return (
    <section className={sectionClassNames}>
      <GatsbyImage
        image={imageToDisplay}
        alt={headerImage.title}
        className="hero-banner__background"
        loading="eager"
      ></GatsbyImage>
      <div className="hero-banner__container position-relative">
        <div className="hero-banner__text">
          <div className="container">
            <div className="row d-flex align-items-center">
              <div className="col">
                <>
                  {preTitleImageToDisplay ? (
                    <GatsbyImage
                      image={preTitleImageToDisplay}
                      alt={headerImage.title}
                      className="header-image-pre_title_image"
                      loading="eager"
                    ></GatsbyImage>
                  ) : null}
                </>
                <h1 className="m-0">
                  <span>{headerImage.title}</span>
                  <span className={subTitleClassNames}>{headerImage.subtitle}</span>
                </h1>
                <div className="row gx-0 hero-banner__text--container">
                  <div className="col-15 col-lg-11 col-xl-9 col-xxl-7">
                    <p>
                      <span>{headerImage.detailedText.detailedText}</span>
                    </p>
                    <div className="optional-items-wrapper">
                      {linkUrl ? (
                        <a href={linkUrl} className="btn is-video homepage-carousel-link">
                          <div className="d-flex justify-content-center align-items-center">
                            <i className="icon-Play"></i>
                            <span>{linkText}</span>
                          </div>
                        </a>
                      ) : null}
                      {videoLink ? (
                        <button
                          className="btn is-video homepage-carousel-link"
                          data-src={videoLink}
                          onClick={openVideoModal}
                        >
                          <div className="d-flex justify-content-center align-items-center">
                            <i className="icon-Play"></i>
                            <span>{videoText}</span>
                          </div>
                        </button>
                      ) : null}
                      {showImiLogo === true ? (
                        <img src="/assets/images/IMI_white.svg" alt="IMI" className="imi_logo" />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomepageCarouselSlideContent
